import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { BaseRestApiService } from '@shared/services/base-rest-api.service';
import { RestApiWrapperService } from '@shared/services/rest-api-wrapper.service';
import { FinanceBusinessPlan } from './project-set-portfolio-business-plan.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FinanceBusinessPlanService extends BaseRestApiService {
  private summaries = environment.serverUri + `api/${environment.apiVersion}/project-groups`;

  constructor(_restApiWrapperService: RestApiWrapperService) {
    super(_restApiWrapperService);
  }

  public getBusinessPlan(projectGroupId: string): Observable<FinanceBusinessPlan> {
    return this.get<FinanceBusinessPlan>(`${this.summaries}/${projectGroupId}/finance/summaries`)
      .pipe(
        map((result: FinanceBusinessPlan) => new FinanceBusinessPlan(result))
      );
  }

  public save(projectGroupId: string, financeBusinessPlan: FinanceBusinessPlan): Observable<any> {
    return this.put<any>(`${this.summaries}/${projectGroupId}/finance/summaries/${financeBusinessPlan.id}`, JSON.stringify(financeBusinessPlan));
  }
}
